module.exports = __webpack_public_path__ + "assets/images/OdinLogob2a2198f33aa458aea51ab4ade900fd4.svg";